import { TYPE_REPORT_WORD } from "constants/IssueInvoiceConstant";

// Tiêu đề hiển thị trên header modal theo từng loại biên bản
export const AGREEMENT_REPORT_TITLE = {
  [TYPE_REPORT_WORD.ADJUST]: "Biên bản thỏa thuận điều chỉnh hóa đơn",
  [TYPE_REPORT_WORD.CANCEL]: "Biên bản thỏa thuận thay thế",
  [TYPE_REPORT_WORD.INFO]:
    "Biên bản thỏa thuận điều chỉnh thông tin khách hàng",
  [TYPE_REPORT_WORD.GRA]: "Biên bản thỏa thuận trả hàng",
  [TYPE_REPORT_WORD.INFO_CANCEL]:
    "Biên bản thỏa thuận thay thế điều chỉnh thông tin",
};

// Ánh xạ tiền tố tên field phẳng sang đường dẫn lồng nhau trong response API.
// Tên field trong form là <prefix>_<key>. Prefix dài phải đứng trước prefix ngắn
// để so khớp không bị nuốt (party_a_before phải xét trước party_b).
export const AGREEMENT_GROUPS = [
  // Bên bán của biên bản điều chỉnh thông tin: seller.company / seller.unit.
  // Phải đứng trước mọi prefix ngắn hơn để không bị nuốt.
  { prefix: "seller_company_before", path: ["seller", "company", "before"] },
  { prefix: "seller_company_after", path: ["seller", "company", "after"] },
  { prefix: "seller_unit_before", path: ["seller", "unit", "before"] },
  { prefix: "seller_unit_after", path: ["seller", "unit", "after"] },
  { prefix: "party_a_before", path: ["party_a", "before"] },
  { prefix: "party_a_after", path: ["party_a", "after"] },
  // Phải đứng SAU party_a_before/after: "party_a_before_name" cũng khớp "party_a_"
  { prefix: "party_a", path: ["party_a"] },
  { prefix: "amounts_before", path: ["amounts", "before"] },
  { prefix: "amounts_after", path: ["amounts", "after"] },
  { prefix: "invoice", path: ["invoice"] },
  { prefix: "party_b", path: ["party_b"] },
];

// Id các dòng hàng GIỮ LẠI của biên bản trả hàng. Không phải field trên form
// nên không nằm trong AGREEMENT_FIELD, nhưng vẫn đi theo giá trị của form.
export const AGREEMENT_ITEM_IDS_FIELD = "item_ids";

// Số lượng trả của từng dòng biên bản trả hàng: { [id dòng]: số lượng }.
// Cũng đi theo giá trị form như item_ids, không phải field trên form.
export const AGREEMENT_ITEM_QUANTITIES_FIELD = "item_quantities";

// Backend tạo file PDF bất đồng bộ, chỉ tải được khi pdf_status đạt giá trị này
export const AGREEMENT_PDF_STATUS_GENERATED = "generated";

// Trạng thái ký của một biên bản (sign_status của agreement-list)
export const AGREEMENT_SIGN_STATUS = {
  DRAFT: "draft",
  PARTIAL: "partial",
  SIGNED: "signed",
};

export const AGREEMENT_SIGN_STATUS_TITLE = {
  [AGREEMENT_SIGN_STATUS.DRAFT]: "Nháp",
  [AGREEMENT_SIGN_STATUS.PARTIAL]: "Đã ký 1 bên",
  [AGREEMENT_SIGN_STATUS.SIGNED]: "Đã ký",
};

// Biên bản chưa hoàn tất: mở modal lập biên bản thì cho chọn lại để xem / ký tiếp
export const AGREEMENT_PENDING_SIGN_STATUSES = [
  AGREEMENT_SIGN_STATUS.DRAFT,
  AGREEMENT_SIGN_STATUS.PARTIAL,
];

const WIDTH_LABEL = "160px";

// Loại bên A (bên mua) — giá trị số vì radio của form helper so bằng Number().
// Khớp hằng Agreement::A_TYPE_* bên mspeinvoice.
export const AGREEMENT_PARTY_A_TYPE = {
  ORGANIZATION: 1,
  INDIVIDUAL: 2,
};

// Loại block trong modal biên bản: mặc định là lưới field, ITEMS là bảng hàng
// hóa, REPRESENTATIVES là lưới người đại diện hai bên, ADJUST_PARTY là khối có
// nút chọn điều chỉnh thông tin bên bán hay bên mua
export const AGREEMENT_BLOCK_TYPE = {
  FIELDS: "FIELDS",
  ITEMS: "ITEMS",
  REPRESENTATIVES: "REPRESENTATIVES",
  ADJUST_PARTY: "ADJUST_PARTY",
};

// Bên được điều chỉnh thông tin ở biên bản điều chỉnh thông tin khách hàng
export const AGREEMENT_ADJUST_PARTY = {
  BUYER: "buyer",
  SELLER: "seller",
};

// Chỉ hiện / chỉ bắt buộc khi đang điều chỉnh thông tin của bên tương ứng
const WHEN_BUYER = {
  field: "adjust_party",
  is: AGREEMENT_ADJUST_PARTY.BUYER,
};
const WHEN_SELLER = {
  field: "adjust_party",
  is: AGREEMENT_ADJUST_PARTY.SELLER,
};

export const AGREEMENT_FIELD = {
  // Bên A (bên mua) — doanh nghiệp hay cá nhân (party_a.type).
  // Là lựa chọn của người lập, không phải dữ liệu hóa đơn, nên không khoá theo
  // các ô "Bên A" còn lại.
  PARTY_A_TYPE: {
    field: "party_a_type",
    labelKey: "party_a_type",
    type: "radioField",
    // Mặc định không chọn sẵn, bấm lưu bắt buộc phải chọn
    required: true,
    listData: [
      { value: AGREEMENT_PARTY_A_TYPE.ORGANIZATION, label: "Doanh nghiệp" },
      { value: AGREEMENT_PARTY_A_TYPE.INDIVIDUAL, label: "Cá nhân" },
    ],
    // Nhãn cùng hàng với radio, thẳng cột với các ô Bên A bên dưới
    widthLabel: WIDTH_LABEL,
    // Chiếm trọn một hàng: row-cols-md-2 của block sẽ ép mọi Col về 50%
    styleCol: { width: "100%" },
  },

  // Thông tin biên bản
  CODE: {
    field: "code",
    type: "text",
    max: 50,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  REPORT_DATE: {
    field: "report_date",
    type: "date",
    widthLabel: WIDTH_LABEL,
    notFeatureDate: false,
    disable: true,
  },
  SIGN_METHOD: {
    field: "sign_method_title",
    type: "text",
    widthLabel: WIDTH_LABEL,
    disable: true,
  },

  // Bên A (bên mua) — thông tin hiện tại trên hóa đơn (party_a.before)
  PARTY_A_BEFORE_NAME: {
    field: "party_a_before_name",
    labelKey: "party_a_name",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_TAX_CODE: {
    field: "party_a_before_tax_code",
    labelKey: "party_a_tax_code",
    type: "text",
    max: 14,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_ADDRESS: {
    field: "party_a_before_address",
    labelKey: "party_a_address",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_CUSTOMER_CODE: {
    field: "party_a_before_customer_code",
    labelKey: "party_a_customer_code",
    type: "text",
    max: 50,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_EMAIL: {
    field: "party_a_before_email",
    labelKey: "party_a_email",
    type: "text",
    max: 100,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_PHONE: {
    field: "party_a_before_phone",
    labelKey: "party_a_phone",
    type: "text",
    max: 20,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_FULL_NAME: {
    field: "party_a_before_full_name",
    labelKey: "party_a_full_name",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_BANK_ACCOUNT: {
    field: "party_a_before_bank_account",
    labelKey: "party_a_bank_account",
    type: "text",
    max: 50,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_BANK_NAME: {
    field: "party_a_before_bank_name",
    labelKey: "party_a_bank_name",
    type: "text",
    max: 200,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_REPRESENTATIVE: {
    field: "party_a_before_representative",
    labelKey: "party_a_representative",
    type: "text",
    max: 100,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_BEFORE_POSITION: {
    field: "party_a_before_position",
    labelKey: "party_a_position",
    type: "text",
    max: 100,
    widthLabel: WIDTH_LABEL,
  },

  // Bên A (bên mua) — thông tin cần điều chỉnh thành (party_a.after)
  PARTY_A_AFTER_NAME: {
    field: "party_a_after_name",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_name",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    requiredWhen: WHEN_BUYER,
  },
  PARTY_A_AFTER_TAX_CODE: {
    field: "party_a_after_tax_code",
    labelKey: "party_a_tax_code",
    type: "text",
    max: 14,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_AFTER_ADDRESS: {
    field: "party_a_after_address",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_address",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    requiredWhen: WHEN_BUYER,
  },
  PARTY_A_AFTER_CUSTOMER_CODE: {
    field: "party_a_after_customer_code",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_customer_code",
    type: "text",
    max: 50,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_AFTER_EMAIL: {
    field: "party_a_after_email",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_email",
    type: "email",
    max: 100,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_AFTER_PHONE: {
    field: "party_a_after_phone",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_phone",
    type: "text",
    max: 20,
    widthLabel: WIDTH_LABEL,
    requiredWhen: WHEN_BUYER,
  },
  PARTY_A_AFTER_FULL_NAME: {
    field: "party_a_after_full_name",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_full_name",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_AFTER_BANK_ACCOUNT: {
    field: "party_a_after_bank_account",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_bank_account",
    type: "text",
    max: 50,
    widthLabel: WIDTH_LABEL,
  },
  PARTY_A_AFTER_BANK_NAME: {
    field: "party_a_after_bank_name",
    visibleWhen: WHEN_BUYER,
    labelKey: "party_a_bank_name",
    type: "text",
    max: 200,
    widthLabel: WIDTH_LABEL,
  },
  // Người đại diện / chức vụ của hai bên nằm ở nhóm "Đại diện các bên" cuối
  // form, sửa được ở MỌI loại biên bản kể cả loại khóa thông tin bên A
  PARTY_A_AFTER_REPRESENTATIVE: {
    field: "party_a_after_representative",
    labelKey: "party_a_representative",
    type: "text",
    max: 100,
    required: true,
  },
  PARTY_A_AFTER_POSITION: {
    field: "party_a_after_position",
    labelKey: "party_a_position",
    type: "text",
    max: 100,
    required: true,
  },

  // Bên B (bên bán)
  PARTY_B_NAME: {
    field: "party_b_name",
    type: "text",
    max: 400,
    // required: true,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  PARTY_B_TAX_CODE: {
    field: "party_b_tax_code",
    type: "text",
    max: 14,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  PARTY_B_ADDRESS: {
    field: "party_b_address",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  PARTY_B_REPRESENTATIVE: {
    field: "party_b_representative",
    type: "text",
    max: 100,
    required: true,
  },
  PARTY_B_POSITION: {
    field: "party_b_position",
    type: "text",
    max: 100,
    required: true,
  },

  // Thông tin hóa đơn
  INVOICE_KHMSHDON: {
    field: "invoice_khmshdon",
    type: "text",
    max: 10,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  INVOICE_KHHDON: {
    field: "invoice_khhdon",
    type: "text",
    max: 10,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  INVOICE_SERIAL: {
    field: "invoice_serial",
    type: "text",
    max: 20,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  INVOICE_NUMBER: {
    field: "invoice_number",
    type: "text",
    max: 20,
    disable: true,
    widthLabel: WIDTH_LABEL,
  },
  // Giữ nguyên chuỗi "YYYY-MM-DD HH:mm:ss" nên để text, không dùng flatpickr
  INVOICE_DATE: {
    field: "invoice_date",
    type: "date",
    max: 30,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },
  INVOICE_DAY: {
    field: "invoice_day",
    type: "text",
    max: 2,
    widthLabel: WIDTH_LABEL,
  },
  INVOICE_MONTH: {
    field: "invoice_month",
    type: "text",
    max: 2,
    widthLabel: WIDTH_LABEL,
  },
  INVOICE_YEAR: {
    field: "invoice_year",
    type: "text",
    max: 4,
    widthLabel: WIDTH_LABEL,
  },

  // Số tiền trước điều chỉnh.
  // Không đặt `max` cho field số: trong bộ dựng schema, max của số là GIÁ TRỊ tối đa
  // chứ không phải độ dài (xem src/pages/TaxDeduct/DetailData.js:423).
  // Số tiền hiện tại trên hóa đơn (amounts.before)
  AMOUNT_BEFORE: {
    field: "amounts_before_amount",
    labelKey: "amounts_amount",
    type: "number",
    widthLabel: WIDTH_LABEL,
    isThousandSeparator: true,
    decimalScale: 0,
    allowNegative: false,
    classText: "text-left",
    disable: true,
  },
  TAX_BEFORE: {
    field: "amounts_before_tax",
    labelKey: "amounts_tax",
    type: "number",
    widthLabel: WIDTH_LABEL,
    isThousandSeparator: true,
    decimalScale: 0,
    allowNegative: false,
    classText: "text-left",
    disable: true,
  },
  TOTAL_BEFORE: {
    field: "amounts_before_total",
    labelKey: "amounts_total",
    type: "number",
    widthLabel: WIDTH_LABEL,
    isThousandSeparator: true,
    decimalScale: 0,
    allowNegative: false,
    classText: "text-left",
    disable: true,
  },
  TOTAL_IN_WORDS_BEFORE: {
    field: "amounts_before_total_in_words",
    labelKey: "amounts_total_in_words",
    type: "text",
    max: 255,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },

  // Số tiền cần điều chỉnh thành (amounts.after)
  AMOUNT_AFTER: {
    field: "amounts_after_amount",
    labelKey: "amounts_amount",
    type: "number",
    widthLabel: WIDTH_LABEL,
    isThousandSeparator: true,
    decimalScale: 0,
    allowNegative: false,
    classText: "text-left",
    required: true,
  },
  TAX_AFTER: {
    field: "amounts_after_tax",
    labelKey: "amounts_tax",
    type: "number",
    widthLabel: WIDTH_LABEL,
    isThousandSeparator: true,
    decimalScale: 0,
    allowNegative: false,
    classText: "text-left",
    required: true,
  },
  // Tự tính = AMOUNT_AFTER + TAX_AFTER nên khoá không cho nhập tay
  TOTAL_AFTER: {
    field: "amounts_after_total",
    labelKey: "amounts_total",
    type: "number",
    widthLabel: WIDTH_LABEL,
    isThousandSeparator: true,
    decimalScale: 0,
    allowNegative: false,
    classText: "text-left",
    required: true,
    disable: true,
  },
  TOTAL_IN_WORDS_AFTER: {
    field: "amounts_after_total_in_words",
    labelKey: "amounts_total_in_words",
    type: "text",
    max: 255,
    widthLabel: WIDTH_LABEL,
    disable: true,
  },

  // Biên bản điều chỉnh thông tin: chọn điều chỉnh thông tin của bên nào.
  // Rỗng = chưa chọn, nhưng biên bản mới luôn được điền sẵn "bên mua".
  ADJUST_PARTY: {
    field: "adjust_party",
    type: "toggleField",
    required: true,
    // Biên bản mới mặc định điều chỉnh thông tin bên mua
    defaultValue: AGREEMENT_ADJUST_PARTY.BUYER,
    listData: [
      { value: AGREEMENT_ADJUST_PARTY.SELLER, label: "Bên bán" },
      { value: AGREEMENT_ADJUST_PARTY.BUYER, label: "Bên mua" },
    ],
    widthLabel: WIDTH_LABEL,
    // Chiếm trọn một hàng: row-cols-md-2 của block sẽ ép mọi Col về 50%
    styleCol: { width: "100%" },
  },

  // Bên bán cần điều chỉnh (seller.company = đơn vị phát hành in trên hóa đơn,
  // seller.unit = đơn vị bán hàng). Chỉ dùng khi điều chỉnh thông tin bên bán.
  SELLER_COMPANY_AFTER_NAME: {
    field: "seller_company_after_name",
    labelKey: "seller_company_name",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    requiredWhen: WHEN_SELLER,
    visibleWhen: WHEN_SELLER,
  },
  SELLER_UNIT_AFTER_NAME: {
    field: "seller_unit_after_name",
    labelKey: "seller_unit_name",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    visibleWhen: WHEN_SELLER,
  },
  SELLER_COMPANY_AFTER_ADDRESS: {
    field: "seller_company_after_address",
    labelKey: "seller_company_address",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    requiredWhen: WHEN_SELLER,
    visibleWhen: WHEN_SELLER,
  },
  SELLER_UNIT_AFTER_ADDRESS: {
    field: "seller_unit_after_address",
    labelKey: "seller_unit_address",
    type: "text",
    max: 400,
    widthLabel: WIDTH_LABEL,
    visibleWhen: WHEN_SELLER,
  },
  SELLER_COMPANY_AFTER_TAX_CODE: {
    field: "seller_company_after_tax_code",
    labelKey: "seller_company_tax_code",
    type: "text",
    max: 14,
    widthLabel: WIDTH_LABEL,
    requiredWhen: WHEN_SELLER,
    visibleWhen: WHEN_SELLER,
  },

  // Lý do
  REASON: {
    field: "reason",
    type: "text",
    max: 500,
    widthLabel: WIDTH_LABEL,
    required: true,
  },
};

// Nhóm "Đại diện các bên": chung cho mọi loại biên bản, đứng ngay trên Lý do
const BLOCK_REPRESENTATIVES = {
  title: "Đại diện các bên",
  type: AGREEMENT_BLOCK_TYPE.REPRESENTATIVES,
  fields: [
    AGREEMENT_FIELD.PARTY_A_AFTER_REPRESENTATIVE,
    AGREEMENT_FIELD.PARTY_A_AFTER_POSITION,
    AGREEMENT_FIELD.PARTY_B_REPRESENTATIVE,
    AGREEMENT_FIELD.PARTY_B_POSITION,
  ],
};

const BLOCKS_ADJUST = [
  {
    title: "Thông tin biên bản",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.CODE,
      AGREEMENT_FIELD.REPORT_DATE,
      AGREEMENT_FIELD.SIGN_METHOD,
    ],
  },
  {
    title: "Thông tin hóa đơn",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.INVOICE_NUMBER,
      AGREEMENT_FIELD.INVOICE_SERIAL,
      AGREEMENT_FIELD.INVOICE_DATE,
      // AGREEMENT_FIELD.INVOICE_KHMSHDON,
      // AGREEMENT_FIELD.INVOICE_KHHDON,

      // AGREEMENT_FIELD.INVOICE_DAY,
      // AGREEMENT_FIELD.INVOICE_MONTH,
      // AGREEMENT_FIELD.INVOICE_YEAR,
    ],
  },
  {
    title: "Bên A (Bên mua)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_A_TYPE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_NAME,
      AGREEMENT_FIELD.PARTY_A_BEFORE_TAX_CODE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_ADDRESS,
    ]?.map(item => {
      return {
        ...item,
        disable: item.field !== AGREEMENT_FIELD.PARTY_A_TYPE.field,
      };
    }),
  },
  {
    title: "Bên B (Bên bán)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_B_NAME,
      AGREEMENT_FIELD.PARTY_B_TAX_CODE,
      AGREEMENT_FIELD.PARTY_B_ADDRESS,
    ],
  },

  {
    title: "Số tiền cần điều chỉnh",
    rowClass: "row-cols-1 row-cols-md-1",
    fields: [
      AGREEMENT_FIELD.AMOUNT_AFTER,
      AGREEMENT_FIELD.TAX_AFTER,
      AGREEMENT_FIELD.TOTAL_AFTER,
      AGREEMENT_FIELD.TOTAL_IN_WORDS_AFTER,
    ],
  },
  BLOCK_REPRESENTATIVES,
  {
    title: "Lý do",
    rowClass: "row-cols-1",
    fields: [AGREEMENT_FIELD.REASON],
  },
];

const BLOCKS_CANCEL = [
  {
    title: "Thông tin biên bản",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.CODE,
      AGREEMENT_FIELD.REPORT_DATE,
      AGREEMENT_FIELD.SIGN_METHOD,
    ],
  },
  {
    title: "Thông tin hóa đơn",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.INVOICE_NUMBER,
      AGREEMENT_FIELD.INVOICE_SERIAL,
      AGREEMENT_FIELD.INVOICE_DATE,
      // AGREEMENT_FIELD.INVOICE_KHMSHDON,
      // AGREEMENT_FIELD.INVOICE_KHHDON,

      // AGREEMENT_FIELD.INVOICE_DAY,
      // AGREEMENT_FIELD.INVOICE_MONTH,
      // AGREEMENT_FIELD.INVOICE_YEAR,
    ],
  },
  {
    title: "Bên A (Bên mua)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_A_TYPE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_NAME,
      AGREEMENT_FIELD.PARTY_A_BEFORE_TAX_CODE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_ADDRESS,
    ]?.map(item => {
      return {
        ...item,
        disable: item.field !== AGREEMENT_FIELD.PARTY_A_TYPE.field,
      };
    }),
  },
  {
    title: "Bên B (Bên bán)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_B_NAME,
      AGREEMENT_FIELD.PARTY_B_TAX_CODE,
      AGREEMENT_FIELD.PARTY_B_ADDRESS,
    ],
  },

  {
    title: "Số tiền cần điều chỉnh",
    rowClass: "row-cols-1 row-cols-md-1",
    fields: [
      AGREEMENT_FIELD.AMOUNT_AFTER,
      AGREEMENT_FIELD.TAX_AFTER,
      AGREEMENT_FIELD.TOTAL_AFTER,
      AGREEMENT_FIELD.TOTAL_IN_WORDS_AFTER,
    ],
  },
  BLOCK_REPRESENTATIVES,
  {
    title: "Lý do",
    rowClass: "row-cols-1",
    fields: [AGREEMENT_FIELD.REASON],
  },
];

// Biên bản điều chỉnh thông tin khách hàng: không có bảng tiền, thay vào đó là
// bảng thông tin khách hàng trước/sau điều chỉnh
const BLOCKS_INFO = [
  {
    title: "Thông tin biên bản",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.CODE,
      AGREEMENT_FIELD.REPORT_DATE,
      AGREEMENT_FIELD.SIGN_METHOD,
    ],
  },
  {
    title: "Thông tin hóa đơn",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.INVOICE_NUMBER,
      AGREEMENT_FIELD.INVOICE_SERIAL,
      AGREEMENT_FIELD.INVOICE_DATE,
    ],
  },
  {
    // Mẫu Word lấy Mã số thuế của bên A từ customer_code
    title: "Bên A (Bên mua)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_A_TYPE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_NAME,
      AGREEMENT_FIELD.PARTY_A_BEFORE_TAX_CODE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_ADDRESS,
    ]?.map(item => {
      return {
        ...item,
        disable: item.field !== AGREEMENT_FIELD.PARTY_A_TYPE.field,
      };
    }),
  },
  {
    title: "Bên B (Bên bán)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_B_NAME,
      AGREEMENT_FIELD.PARTY_B_TAX_CODE,
      AGREEMENT_FIELD.PARTY_B_ADDRESS,
    ],
  },
  {
    // Cột "Sau điều chỉnh" của mẫu Word. Người lập chọn điều chỉnh thông tin
    // bên mua (party_a.after) hay bên bán (seller.*); mỗi bên một bộ ô nhập,
    // ô nào không thuộc bên đang chọn thì ẩn và không bắt buộc.
    title: "Thông tin khách hàng cần điều chỉnh",
    type: AGREEMENT_BLOCK_TYPE.ADJUST_PARTY,
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.ADJUST_PARTY,

      AGREEMENT_FIELD.PARTY_A_AFTER_FULL_NAME,
      AGREEMENT_FIELD.PARTY_A_AFTER_CUSTOMER_CODE,
      AGREEMENT_FIELD.PARTY_A_AFTER_NAME,
      AGREEMENT_FIELD.PARTY_A_AFTER_BANK_ACCOUNT,
      AGREEMENT_FIELD.PARTY_A_AFTER_BANK_NAME,

      AGREEMENT_FIELD.PARTY_A_AFTER_EMAIL,
      AGREEMENT_FIELD.PARTY_A_AFTER_PHONE,
      AGREEMENT_FIELD.PARTY_A_AFTER_ADDRESS,

      AGREEMENT_FIELD.SELLER_COMPANY_AFTER_NAME,
      AGREEMENT_FIELD.SELLER_UNIT_AFTER_NAME,
      AGREEMENT_FIELD.SELLER_COMPANY_AFTER_ADDRESS,
      AGREEMENT_FIELD.SELLER_UNIT_AFTER_ADDRESS,
      AGREEMENT_FIELD.SELLER_COMPANY_AFTER_TAX_CODE,
    ],
  },
  BLOCK_REPRESENTATIVES,
  {
    title: "Lý do",
    rowClass: "row-cols-1",
    fields: [AGREEMENT_FIELD.REASON],
  },
];

// Biên bản trả hàng: bảng hàng hóa để trống trong mẫu Word (API không trả về),
// chỉ nhập phần tổng tiền
const BLOCKS_GRA = [
  {
    title: "Thông tin biên bản",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.CODE,
      AGREEMENT_FIELD.REPORT_DATE,
      AGREEMENT_FIELD.SIGN_METHOD,
    ],
  },
  {
    title: "Thông tin hóa đơn",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.INVOICE_NUMBER,
      AGREEMENT_FIELD.INVOICE_SERIAL,
      AGREEMENT_FIELD.INVOICE_DATE,
    ],
  },
  {
    title: "Bên A (Bên mua)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_A_TYPE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_NAME,
      AGREEMENT_FIELD.PARTY_A_BEFORE_TAX_CODE,
      AGREEMENT_FIELD.PARTY_A_BEFORE_ADDRESS,
    ]?.map(item => {
      return {
        ...item,
        disable: item.field !== AGREEMENT_FIELD.PARTY_A_TYPE.field,
      };
    }),
  },
  {
    title: "Bên B (Bên bán)",
    rowClass: "row-cols-1 row-cols-md-2",
    fields: [
      AGREEMENT_FIELD.PARTY_B_NAME,
      AGREEMENT_FIELD.PARTY_B_TAX_CODE,
      AGREEMENT_FIELD.PARTY_B_ADDRESS,
    ],
  },
  {
    // Bảng hàng hóa trả lại: API trả về ở data.items, hiển thị đúng thứ tự của
    // mẫu Word (bảng hàng hóa nằm trên phần tổng tiền)
    title: "Hàng hóa trả lại",
    type: AGREEMENT_BLOCK_TYPE.ITEMS,
    fields: [],
  },
  {
    title: "Số tiền trả hàng",
    rowClass: "row-cols-1 row-cols-md-1",
    fields: [
      AGREEMENT_FIELD.AMOUNT_AFTER,
      AGREEMENT_FIELD.TAX_AFTER,
      AGREEMENT_FIELD.TOTAL_AFTER,
      AGREEMENT_FIELD.TOTAL_IN_WORDS_AFTER,
    ],
  },
  BLOCK_REPRESENTATIVES,
  {
    title: "Lý do",
    rowClass: "row-cols-1",
    fields: [AGREEMENT_FIELD.REASON],
  },
];

/**
 * Lấy danh sách block field theo loại biên bản.
 * ADJUST và CANCEL dùng chung một bộ field, INFO và GRA có bộ riêng theo mẫu Word.
 */
export const getFieldBlocksByType = type => {
  switch (type) {
    case TYPE_REPORT_WORD.ADJUST:
      return BLOCKS_ADJUST;
    case TYPE_REPORT_WORD.CANCEL:
      return BLOCKS_CANCEL;
    case TYPE_REPORT_WORD.INFO:
    // Biên bản thay thế điều chỉnh thông tin của hóa đơn MTT dùng chung bộ
    // field với biên bản điều chỉnh thông tin khách hàng
    case TYPE_REPORT_WORD.INFO_CANCEL:
      return BLOCKS_INFO;
    case TYPE_REPORT_WORD.GRA:
      return BLOCKS_GRA;
    default:
      return [];
  }
};

export const getAllFieldsByType = type =>
  getFieldBlocksByType(type).reduce(
    (result, block) => result.concat(block.fields),
    []
  );
